import getImagePath from "../../utils/image-helper";

const business = getImagePath('icons/business.png');
const covid = getImagePath('icons/covid-19.png');
const Environment = getImagePath('icons/envoroment.png');
const markets = getImagePath('icons/markets.png');
const Sports = getImagePath('icons/sports.png');
const world = getImagePath('icons/world.png');
const economy = getImagePath('icons/economy.png');
const Chaos = getImagePath('icons/chaos.png');
const politics = getImagePath('icons/politics.png');
const healthcare = getImagePath("icons/healthcare.png");

export function renderBorderColor(colorVal){
    let color 
    if(colorVal ==='Health')
        return color='#ECB731'
    if(colorVal === "Business")
        return color ='#A97DF1'
    if(colorVal === "Choas")
        return color ="#55C79A"
    if(colorVal ==='Covid-19')
        return color='#EC3131'
    if(colorVal === "Ecomony" || colorVal === "Nation" )
        return color ="#31BFEC"
    if(colorVal === "Markets")
        return color ="#EC31C3"
    if(colorVal ==='Sports')
        return color="#5DC5BE"
    if(colorVal === "World")
        return color ="#3531EC"
    if(colorVal === "politics")
        return color ="#DE0046"

    return color ="#55C79A"

  }

  export function categoryImage(category){
    let image 
    if(category ==='Health')
       return image=healthcare
    if(category === "Business")
       return image =business
    if(category === "Chaos")
        return image =Chaos
    if(category ==='Covid-19')
       return image=covid
    if(category === "Ecomony" || category === "Nation" )
       return image =economy
    if(category === "Markets")
        return image =markets
    if(category ==='Sports')
        return image=Sports
    if(category === "World")
        return image =world
    if(category === "politics")
        return image =politics
    if(category === 'Environment')
        return Environment

}
  